<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
};
</script>
<style>
/* Estilos Gerais e variaveis */

@import url("assets/css/variables.css");
@import url("assets/css/material.css");

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

@font-face {
  font-family: "AlternateGotNo2d";
  src: url("assets/fonts/AlternateGotNo2D.ttf");
}

html,
body {
  height: 100%;
}

body {
  max-width: 100%;
  height: 100%;
  background-color: #006491 !important;
  font-family: "AlternateGotNo2d" !important;
}

#app {
  height: 100%;
  margin: 0 !important;
  width: 100%;
}

input[type="radio"] {
  cursor: pointer;
}

button {
  cursor: pointer;
}

.btn.disabled {
  background-color: none;
}

.thankyou {
  width: 100%;
  text-align: center;
  margin-top: 120px;
}

.img-thankyou {
  max-width: 100%;
}

.thankyou > img {
  max-width: 80%;
  margin-bottom: 30px;
}

@media screen and (max-width: 580px) {
  .thankyou {
    margin-top: 20px;
  }
}
</style>
